import useSWRGas from "./useSWRGas";
const useOutOfGas = ({ address, network, token, amount, balances, minAllowedAmount, maxAllowedAmount }) => {
    const { gasData } = useSWRGas(address, network, token, amount);
    const nativeTokenBalance = balances?.find(b => b.token === network?.token?.symbol);
    const balance = nativeTokenBalance?.amount;
    const isNativeToken = nativeTokenBalance?.isNativeCurrency && token?.symbol === network?.token?.symbol;
    if (balance == null || !gasData || !amount || !isNativeToken || minAllowedAmount == null || maxAllowedAmount == null) {
        return { outOfGas: false };
    }
    const numAmount = Number(amount);
    const totalNeeded = numAmount + gasData.gas;
    const balanceCoversAmount = numAmount <= balance;
    const balanceExceedsMaxWithGas = balance > (maxAllowedAmount + gasData.gas);
    const balanceAboveMin = balance > minAllowedAmount;
    const outOfGas = totalNeeded > balance
        && balanceCoversAmount
        && balanceAboveMin
        && !balanceExceedsMaxWithGas;
    return { outOfGas };
};
export default useOutOfGas;
